
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarRainIec as ObiRadarRainIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-rain-iec.js';
 
 
 

 
 export const ObiRadarRainIec = createComponent({
   react: React,
   tagName: 'obi-radar-rain-iec',
   elementClass: ObiRadarRainIecElement,
   events: {
     
   }
  });
 
 